module.exports = __webpack_public_path__ + "static/media/blue_back.6c4e35e0.jfif";